import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function FacebookSvg({ classNameProps, height, width }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 31 30'
      fill='none'
    >
      <path
        d='M27.5001 14.9938C27.5001 8.37314 22.1242 3 15.5001 3C8.876 3 3.5001 8.37314 3.5001 14.9938C3.5001 20.9846 7.88733 25.9501 13.634 26.8394V18.4524H10.5691V14.9938H13.634V12.3505C13.634 9.34895 15.4136 7.68142 18.1572 7.68142C19.4671 7.68142 20.8266 7.92847 20.8266 7.92847V10.8559H19.3188C17.8235 10.8559 17.3539 11.7947 17.3539 12.7334V14.9815H20.6906L20.1592 18.4401H17.3539V26.8271C23.1129 25.9501 27.5001 20.9846 27.5001 14.9938Z'
        fill='#1877F2'
      />
      <path
        d='M20.1715 18.4648L20.7029 15.0063H17.3662V12.7582C17.3662 11.8071 17.8482 10.8807 19.3312 10.8807H20.8389V7.94089C20.8389 7.94089 19.4795 7.69385 18.1695 7.69385C15.4259 7.69385 13.6463 9.36137 13.6463 12.3629V15.0063H10.5814V18.4648H13.6463V26.8519C14.2519 26.9507 14.8821 27.0001 15.5124 27.0001C16.1427 27.0001 16.773 26.9507 17.3785 26.8519V18.4648H20.1715Z'
        fill='white'
      />
    </svg>
  );
}

export default FacebookSvg;
